export default "__VITE_ASSET__JPtYD_mU__"